import { useState } from 'react';
import { Row, Col, Form, FormGroup, Label, Input, Button, UncontrolledTooltip } from 'reactstrap';
import PhoneNotification from './PhoneNotification';
import ImageSelectorModal from '../modal/ImageSelectorModal';
import { FaArrowRight, FaArrowLeft, FaInfoCircle } from "react-icons/fa";

const DeeplinkComponent = ({
    selectedFile,
    selectedButtons,
    setSelectedIcon,
    toggleButtonSelection,
    phoneScreen,
    deepLink,
    handleDeepLinkChange,
    imageUrl,
    updateCampaignData
}) => {
    const [isImageSelectorOpen, setIsImageSelectorOpen] = useState(false);

    const toggleImageSelector = () => {
        setIsImageSelectorOpen(!isImageSelectorOpen);
    };

    const handleImageSelect = (image) => {
        
        if (image && image.url) {
            try {
                if (typeof updateCampaignData === 'function') {
                    updateCampaignData({ imageUrl: image.url });
                } else {
                    console.warn('updateCampaignData is not a function');
                }
            } catch (error) {
                console.error('Error updating campaign data:', error);
            }
        }
    };

    return (
        <div style={{ borderRadius: '5px', overflow: 'hidden' }}>
            <Row>
                {/* Left Side */}
                <Col md={{ size: 9, offset: 0 }}>
                    <Form style={{ marginRight: '0px', marginTop: '20px' }}>

                    <FormGroup row>
                            <Label for="deeplink" md={2}>URL</Label>
                            <Col md={10}>
                                <Input
                                    id="deeplink"
                                    name="deeplink"
                                    placeholder="Enter Deeplink URL"
                                    value={deepLink}
                                    onChange={handleDeepLinkChange}
                                />
                            </Col>
                        </FormGroup>

                        <FormGroup row>
                            <Label for="media" md={2}>
                                Media <FaInfoCircle id="deeplinkMediaTooltip" className="ms-1 text-primary" style={{ cursor: 'pointer' }} />
                            </Label>
                            <Col md={10}>
                                <Button
                                    color="primary"
                                    onClick={toggleImageSelector}
                                    style={{
                                        backgroundColor: '#CC1977',
                                        border: 'none',
                                        borderRadius: '5px'
                                    }}
                                >
                                    Select Image
                                </Button>
                            </Col>
                        </FormGroup>
                        
                        <UncontrolledTooltip placement="right" target="deeplinkMediaTooltip">
                            <div className="text-start">
                                <p className="mb-1">• Image resolution should be 360x480 px</p>
                                <p className="mb-1">• Only jpeg and png images will be accepted</p>
                                <p className="mb-0">• Maximum size is 100 Kbytes</p>
                            </div>
                        </UncontrolledTooltip>

                        <FormGroup row>
                            <Label for="buttons" md={2}>Buttons</Label>
                            <Col md={10}>
                                <div className="d-flex gap-2">
                                <Button
                                    style={{
                                        background: '#00FFFF',
                                        borderColor: '#00FFFF',
                                        fontSize: '14px',
                                        color: selectedButtons.includes('accept') ? 'white' : '#000',
                                        borderRadius: '5px'
                                    }}
                                    disabled
                                >
                                    Accept
                                </Button>

                                <Button
                                    color={selectedButtons.includes('cancel') ? "primary" : "secondary"}
                                    onClick={() => toggleButtonSelection('cancel')}
                                    style={{
                                        backgroundColor: selectedButtons.includes('cancel') ? '#CC1977' : '#6c757d',
                                        border: 'none'
                                    }}
                                >
                                    Cancel
                                </Button>
                                </div>
                            </Col>
                        </FormGroup>

                        <div className="d-flex justify-content-between mt-4">
                            <Button
                                color="secondary"
                                onClick={() => setSelectedIcon(0)}
                                style={{
                                    backgroundColor: '#6c757d',
                                    border: 'none'
                                }}
                            >
                                <FaArrowLeft className="me-2" /> Back: When
                            </Button>
                            <Button
                                color="primary"
                                onClick={() => setSelectedIcon(3)}
                                style={{
                                    backgroundColor: '#CC1977',
                                    border: 'none'
                                }}
                            >
                                Next: Publish <FaArrowRight className="ms-2" />
                            </Button>
                        </div>
                    </Form>
                </Col>

                {/* Right Side */}
                <PhoneNotification 
                    phoneScreen={phoneScreen} 
                    selectedFile={selectedFile} 
                    selectedButtons={selectedButtons} 
                    imageUrl={imageUrl}
                />
            </Row>

            {/* Image Selector Modal */}
            <ImageSelectorModal 
                isOpen={isImageSelectorOpen} 
                toggle={toggleImageSelector} 
                onSelectImage={handleImageSelect}
            />
        </div>
    );
};

export default DeeplinkComponent;
